// 2025-04-14
export function formatDate(d, showDay) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const [year, month, day] = d.split("-");

  return showDay
    ? `${days[new Date(d).getDay()]}, ${day} ${months[+month - 1]}, ${year}`
    : `${day} ${months[+month - 1]}, ${year}`;
}

export function formatTimeSlot(slot) {
  if (!slot || typeof slot !== "string") return "Not Available";

  const [startRaw, endRaw] = slot.split(" - ");
  if (!startRaw || !endRaw) return "Not Available";

  const formatTo12Hour = (timeStr) => {
    const cleaned = timeStr.trim().replace(/\s?(AM|PM)$/i, "");
    const [hours, minutes] = cleaned.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes)) return null;

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const start = formatTo12Hour(startRaw);
  const end = formatTo12Hour(endRaw);

  return start && end ? `${start} - ${end}` : "Not Available";
}

export function getLifecycleClassName(lifecycle) {
  switch (lifecycle) {
    default:
    case "pending":
      return "Pending";
      break;
    case "approved":
      return "Awaiting";
      break;
    case "rejected":
      return "Failed";
      break;
    case "deleted":
      return "Abandoned";
      break;
  }
}

export function getLifecycleProgressbarClass(lifecycle) {
  switch (lifecycle) {
    default:
    case "approved":
    case "pending":
      return "progress-require-approval";
      break;
    case "rejected":
      return "progress-rejected-approval";
      break;
    case "deleted":
      return "progress-abandoned-transaction";
      break;
  }
}

export function processLifecycleName(name, services) {
  switch (name) {
    case "pending":
      if (services?.includes("BAScheduledTxn")) {
        return "Require approval";
      } else {
        return "Pending";
      }
      break;
    case "deleted":
      return "Discarded";
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
}
